exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ngx-gallery-arrow-wrapper {\n  position: absolute;\n  height: 100%;\n  width: 1px;\n  display: table;\n  z-index: 2000;\n  table-layout: fixed; }\n\n.ngx-gallery-arrow-left {\n  left: 0px; }\n\n.ngx-gallery-arrow-right {\n  right: 0px; }\n\n.ngx-gallery-arrow {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  cursor: pointer; }\n  .ngx-gallery-arrow.ngx-gallery-disabled {\n    opacity: 0.6;\n    cursor: default; }\n\n.ngx-gallery-arrow-left .ngx-gallery-arrow {\n  left: 10px; }\n\n.ngx-gallery-arrow-right .ngx-gallery-arrow {\n  right: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/ngx-gallery/ngx-gallery-arrows.component.scss
// module id = ../../../../../src/app/components/ngx-gallery/ngx-gallery-arrows.component.scss
// module chunks = main